// extracted by mini-css-extract-plugin
export default {"button":"CartButton-button_Fuxm_"};